export const BASE_API_URL = process.env.VUE_APP_BASE_API_URL;
export const EXPORT_URL = process.env.VUE_APP_EXPORT_URL;